<div class="card right">

  <div class="ui-g-12">
    <h1 class="campaign-step">{{ 'campaign.clientsTarget' | translate }}</h1>
  </div>

  <div class="ui-g-12">
    <div class="ui-g-6" *ngFor="let segment of segments">
      <button pButton type="button" class="Segment" label="{{ segment.descrizione_cluster }}" [ngClass]="{ 'active': isSelected(segment.codice_sigla) }" (click)="toggleSegment(segment.codice_sigla)"></button>
    </div>
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/step-4/segments/campaign-segments.html